export default "__VITE_ASSET__874419b8__"